// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cell-container .van-cell {\n  height: 1.86667rem;\n  line-height: 0.69333rem;\n  display: flex;\n  align-items: center;\n}\n.right-arrow {\n  width: 0.42667rem;\n  height: 0.42667rem;\n}\n.van-cell__title .custom-icon {\n  width: 0.53333rem;\n  height: 0.53333rem;\n  margin-right: 0.42667rem;\n}\n.van-cell__title .custom-title {\n  font-size: 0.37333rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n", ""]);
// Exports
module.exports = exports;
